import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import styled from 'styled-components';

export interface LabelType2Props {
  labelValue: string;
}

const LabelType2 = ({ labelValue }: LabelType2Props) => {
  return (
    <>
      {labelValue === 'A' && <Label2Typel>{labelValue}</Label2Typel>}
      {labelValue === 'B' && <Label2Type2>{labelValue}</Label2Type2>}
      {labelValue === 'C' && <Label2Type3>{labelValue}</Label2Type3>}
      {labelValue === 'D' && <Label2Type4>{labelValue}</Label2Type4>}
      {labelValue === 'E' && <Label2Type5>{labelValue}</Label2Type5>}
    </>
  );
};

export default LabelType2;

export const Label2Type = styled.span`
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
`;

export const Label2Typel = styled(Label2Type)`
  color: #32a877;
  background-color: #cff7e9;
`;

export const Label2Type2 = styled(Label2Type)`
  color: #5c6fc6;
  background-color: #e6eafd;
`;

export const Label2Type3 = styled(Label2Type)`
  color: #9246c5;
  background-color: #f2e6fd;
`;

export const Label2Type4 = styled(Label2Type)`
  color: #e16119;
  background-color: #fdeed8;
`;
export const Label2Type5 = styled(Label2Type)`
  color: #e83a32;
  background-color: #feeae9;
`;
